"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.qualityPaths = exports.fillColors = exports.Quality = void 0;
var theme_1 = __importDefault(require("../../../styles/theme"));
var styleUtilities_1 = require("../../../util/styleUtilities");
var Quality;
(function (Quality) {
    Quality["Good"] = "good";
    Quality["Medium"] = "medium";
    Quality["Poor"] = "poor";
    Quality["Unavailable"] = "unavailable";
})(Quality = exports.Quality || (exports.Quality = {}));
var gray = (0, styleUtilities_1.withOpacity)(theme_1.default.colors.dark, 0.2);
exports.fillColors = {
    good: [theme_1.default.colors.tertiary, theme_1.default.colors.tertiary, theme_1.default.colors.tertiary],
    medium: [theme_1.default.colors.warning, theme_1.default.colors.warning, gray],
    poor: [theme_1.default.colors.error, gray, gray],
    unavailable: [gray, gray, gray],
};
exports.qualityPaths = [
    'M7,13h1c0.6,0,1,0.4,1,1v3c0,0.6-0.4,1-1,1H7c-0.6,0-1-0.4-1-1v-3C6,13.4,6.4,13,7,13z',
    'M11.5,10h1c0.6,0,1,0.4,1,1v6c0,0.6-0.4,1-1,1h-1c-0.6,0-1-0.4-1-1v-6,C10.5,10.4,10.9,10,11.5,10z',
    'M16,6h1c0.6,0,1,0.4,1,1v10c0,0.6-0.4,1-1,1h-1c-0.6,0-1-0.4-1-1V7C15,6.4,15.4,6,16,6z',
];
